// import axios from 'axios';

export default {
  performSimpleSearch(payload) {
    let url = `/search?`;
    let params = { ...payload };
    if (payload.moduleInstances) params.moduleInstances = payload.moduleInstances.join(',');

    //console.debug('api params', JSON.stringify(params, null, 2));
    return fetch(url, { params });
    // return axios.get(url, { params });
  },
};
